import { presetPalettes } from '@ant-design/colors';
import { theme } from './theme.util';

export default {
  gray: 'gray',
  green: 'green',
  red: 'red',
  lightgrey: 'lightgrey',
  lightgreen: 'lightgreen',
  geekblue: 'geekblue',
  error: 'error',
  gold: 'gold',
  daybreak: '#91D5FF',
  goldenPurple: '#D3ADF7'
};

export interface SelectNameValue {
  name: string;
  value: string;
}

const primaryColorIndex = 5;

export const allPrimaryColorsFromAntPalate = (): SelectNameValue[] =>
  Object.keys(presetPalettes).map((palate) => {
    return { value: presetPalettes[palate][primaryColorIndex], name: palate };
  });

export const getAllNestedColors = (color: string): SelectNameValue[] =>
  presetPalettes[color]
    .filter((subcolor, index) => index !== primaryColorIndex)
    .map((subColor) => {
      return { name: color, value: subColor };
    });

export const getColorByValue = (
  value: number,
  maxValue: number,
  neutralValue?: { value: number; isRange: boolean }
): string => {
  if (value > maxValue) {
    return theme.colors.boolean.no;
  }
  if (
    neutralValue &&
    (value === neutralValue.value ||
      (neutralValue.isRange &&
        neutralValue.value <= value &&
        value <= maxValue))
  ) {
    return theme.colors.gray.gray70;
  }
  return theme.colors.boolean.yes;
};
